<script>
export default {
  name: "LiveOnIcon",
};
</script>

<style lang="scss">
.live-on-icon {
  display: block;
  float: left;
  svg {
    width: 38px;
    position: relative;
    top: -5px;
  }
}
</style>

<template>
  <div class="live-on-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M19.5 23.9979V21.5978C19.5 18.5178 21.68 17.2579 24.34 18.7979L26.42 19.9979L28.5 21.1978C31.16 22.7378 31.16 25.2579 28.5 26.7979L26.42 27.9979L24.34 29.1978C21.68 30.7378 19.5 29.4779 19.5 26.3979V23.9979Z"
        fill="#2ED810"
      />
      <path
        d="M40 36C42.52 32.66 44 28.5 44 24C44 19.5 42.52 15.34 40 12"
        stroke="#2ED810"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 12C5.48 15.34 4 19.5 4 24C4 28.5 5.48 32.66 8 36"
        stroke="#2ED810"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33.5996 31.1969C35.0996 29.1969 35.9996 26.6969 35.9996 23.9969C35.9996 21.2969 35.0996 18.7969 33.5996 16.7969"
        stroke="#2ED810"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.4 16.7969C12.9 18.7969 12 21.2969 12 23.9969C12 26.6969 12.9 29.1969 14.4 31.1969"
        stroke="#2ED810"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
